//#region ../../node_modules/@jwplayer/fe-common/module/util/error/index.js
const STRIP = "AbortError: ";
var AbortError = class extends Error {
	name = "AbortError";
	constructor(signal) {
		let reason = "Unknown Error";
		if (signal instanceof AbortSignal) {
			reason = String(signal.reason);
			reason = reason.startsWith(STRIP) ? reason.slice(12) : reason;
		}
		super(reason);
	}
};

//#endregion
export { AbortError };